var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import MuiTab from '@mui/material/Tab';
import Typography from '../Typography';
import colors from '../../colors';
import { LabelWithBadge } from './LabelWithBadge';
import { LabelWithChip } from './LabelWithChip';
var renderLabel = function (_a) {
    var label = _a.label, badgeLabel = _a.badgeLabel, chipLabel = _a.chipLabel, disabled = _a.disabled, isActive = _a.isActive;
    if (badgeLabel) {
        return (_jsx(LabelWithBadge, { isActive: isActive, label: label, badgeLabel: badgeLabel }));
    }
    if (chipLabel || disabled) {
        return (_jsx(LabelWithChip, { isActive: isActive, label: label, chipLabel: disabled ? 'Coming soon' : chipLabel !== null && chipLabel !== void 0 ? chipLabel : '' }));
    }
    return (_jsx(Typography, __assign({ color: isActive ? colors.blue[500] : colors.grey[800], variant: 'body' }, { children: label })));
};
export var Tab = function (props) {
    var label = props.label, badgeLabel = props.badgeLabel, chipLabel = props.chipLabel, disabled = props.disabled, isActive = props.isActive, restProps = __rest(props, ["label", "badgeLabel", "chipLabel", "disabled", "isActive"]);
    return (_jsx(MuiTab, __assign({ label: renderLabel({ badgeLabel: badgeLabel, label: label, chipLabel: chipLabel, disabled: disabled, isActive: isActive }), disabled: disabled }, restProps, { sx: {
            borderBottom: "1px solid ".concat(isActive ? colors.blue[500] : 'transparent'),
            opacity: 1,
        } })));
};
